import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import MapLoader from "./MapLoader";
import "./map.scss";
import { shallowEqual, useSelector } from "react-redux";
import { selectTheme } from "../../features/data/theme/themeSlice";

export const Map = (props) => {
  const { style, options, onInit, defaultCoords, getMapData, disabled, row = false, print = false, zoom = 17 } = props;
  const mapCenter = [32.63296053018298, 51.3655310869217];

  const { theme } = useSelector(selectTheme, shallowEqual);

  const randomId = useRef(Date.now() * Math.random() * 1000000);
  const mapRef = useRef(null);

  const defaultStyle = {
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    background: "#eee",
    borderRadius: 10,
    overflow: "hidden",
  };

  const defaultOptions = {
    // key: "web.sjsajoijdkajldk",
    key: "web.gaB38h08jjvDNVmWpWeNGiV9uqgxreTC44OW0j9T",
    maptype: theme === "dark" || print ? "neshan" : "dreamy-gold",
    poi: true,
    traffic: false,
    center: row ? [mapCenter[0], mapCenter[1] + 0.0009] : mapCenter,
    zoom: zoom,
  };

  const updateMap = (point) => {
    if (mapRef.current) {
      mapRef.current.marker.setLatLng(point);
      mapRef.current.instance.setView(row ? [point[0], point[1] + 0.0009] : point, 17, { animate: true });
      if (getMapData) getMapData(point);
    }
  };

  useEffect(() => {
    if (mapRef.current) mapRef.current.instance.setMapType(theme === "dark" ? "standard-night" : "dreamy-gold");
  }, [theme]);

  useEffect(() => {
    setTimeout(() => {
      if (defaultCoords?.length > 0) {
        updateMap(defaultCoords);
      }
    }, 300);
  }, [defaultCoords]); // eslint-disable-line

  useEffect(() => {
    MapLoader({
      onLoad: () => {
        let map = new window.L.Map(`${randomId.current}`, { ...defaultOptions, ...options });
        let marker = window.L.marker(mapCenter).addTo(map);
        map.on("click", (e) => updateMap([e.latlng.lat, e.latlng.lng]));
        mapRef.current = { id: randomId.current, instance: map, marker: marker };
        if (onInit) onInit(window.L, map, marker);
      },
      onError: () => {
        console.error("Maps Error: This page didn't load Maps correctly");
      },
    });
  }, []); // eslint-disable-line

  return /*#__PURE__*/ React.createElement("div", {
    id: randomId.current,
    style: { ...defaultStyle, ...style },
    className: `${disabled && `map-disabled`}`,
  });
};

Map.propTypes = {
  getMapData: PropTypes.func.isRequired,
  defaultCoords: PropTypes.array,
  disabled: PropTypes.bool,
};

export default Map;
